/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SendblueMessageReference } from './SendblueMessageReference';
import {
    SendblueMessageReferenceFromJSON,
    SendblueMessageReferenceFromJSONTyped,
    SendblueMessageReferenceToJSON,
    SendblueMessageReferenceToJSONTyped,
} from './SendblueMessageReference';

/**
 * 
 * @export
 * @interface SendblueMessageWebhook
 */
export interface SendblueMessageWebhook {
    /**
     * 
     * @type {string}
     * @memberof SendblueMessageWebhook
     */
    accountEmail: string;
    /**
     * 
     * @type {string}
     * @memberof SendblueMessageWebhook
     */
    content: string;
    /**
     * 
     * @type {boolean}
     * @memberof SendblueMessageWebhook
     */
    isOutbound: boolean;
    /**
     * 
     * @type {string}
     * @memberof SendblueMessageWebhook
     */
    status: string;
    /**
     * 
     * @type {number}
     * @memberof SendblueMessageWebhook
     */
    errorCode?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SendblueMessageWebhook
     */
    errorMessage?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SendblueMessageWebhook
     */
    errorReason?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SendblueMessageWebhook
     */
    errorDetail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SendblueMessageWebhook
     */
    messageHandle: string;
    /**
     * 
     * @type {Date}
     * @memberof SendblueMessageWebhook
     */
    dateSent: Date;
    /**
     * 
     * @type {Date}
     * @memberof SendblueMessageWebhook
     */
    dateUpdated?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof SendblueMessageWebhook
     */
    fromNumber: string;
    /**
     * 
     * @type {string}
     * @memberof SendblueMessageWebhook
     */
    number: string;
    /**
     * 
     * @type {string}
     * @memberof SendblueMessageWebhook
     */
    toNumber: string;
    /**
     * 
     * @type {boolean}
     * @memberof SendblueMessageWebhook
     */
    wasDowngraded?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof SendblueMessageWebhook
     */
    plan?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SendblueMessageWebhook
     */
    mediaUrl: string;
    /**
     * 
     * @type {string}
     * @memberof SendblueMessageWebhook
     */
    messageType: string;
    /**
     * 
     * @type {string}
     * @memberof SendblueMessageWebhook
     */
    groupId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SendblueMessageWebhook
     */
    participants: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SendblueMessageWebhook
     */
    sendStyle?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SendblueMessageWebhook
     */
    optedOut: boolean;
    /**
     * 
     * @type {string}
     * @memberof SendblueMessageWebhook
     */
    sendblueNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SendblueMessageWebhook
     */
    service: string;
    /**
     * 
     * @type {string}
     * @memberof SendblueMessageWebhook
     */
    groupDisplayName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SendblueMessageWebhook
     */
    senderEmail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SendblueMessageWebhook
     */
    seatId?: string | null;
    /**
     * 
     * @type {SendblueMessageReference}
     * @memberof SendblueMessageWebhook
     */
    replyTo?: SendblueMessageReference | null;
    /**
     * 
     * @type {SendblueMessageReference}
     * @memberof SendblueMessageWebhook
     */
    threadOriginator?: SendblueMessageReference | null;
}

/**
 * Check if a given object implements the SendblueMessageWebhook interface.
 */
export function instanceOfSendblueMessageWebhook(value: object): value is SendblueMessageWebhook {
    if (!('accountEmail' in value) || value['accountEmail'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('isOutbound' in value) || value['isOutbound'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('messageHandle' in value) || value['messageHandle'] === undefined) return false;
    if (!('dateSent' in value) || value['dateSent'] === undefined) return false;
    if (!('fromNumber' in value) || value['fromNumber'] === undefined) return false;
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('toNumber' in value) || value['toNumber'] === undefined) return false;
    if (!('mediaUrl' in value) || value['mediaUrl'] === undefined) return false;
    if (!('messageType' in value) || value['messageType'] === undefined) return false;
    if (!('groupId' in value) || value['groupId'] === undefined) return false;
    if (!('participants' in value) || value['participants'] === undefined) return false;
    if (!('optedOut' in value) || value['optedOut'] === undefined) return false;
    if (!('service' in value) || value['service'] === undefined) return false;
    return true;
}

export function SendblueMessageWebhookFromJSON(json: any): SendblueMessageWebhook {
    return SendblueMessageWebhookFromJSONTyped(json, false);
}

export function SendblueMessageWebhookFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendblueMessageWebhook {
    if (json == null) {
        return json;
    }
    return {
        
        'accountEmail': json['accountEmail'],
        'content': json['content'],
        'isOutbound': json['is_outbound'],
        'status': json['status'],
        'errorCode': json['error_code'] == null ? undefined : json['error_code'],
        'errorMessage': json['error_message'] == null ? undefined : json['error_message'],
        'errorReason': json['error_reason'] == null ? undefined : json['error_reason'],
        'errorDetail': json['error_detail'] == null ? undefined : json['error_detail'],
        'messageHandle': json['message_handle'],
        'dateSent': (new Date(json['date_sent'])),
        'dateUpdated': json['date_updated'] == null ? undefined : (new Date(json['date_updated'])),
        'fromNumber': json['from_number'],
        'number': json['number'],
        'toNumber': json['to_number'],
        'wasDowngraded': json['was_downgraded'] == null ? undefined : json['was_downgraded'],
        'plan': json['plan'] == null ? undefined : json['plan'],
        'mediaUrl': json['media_url'],
        'messageType': json['message_type'],
        'groupId': json['group_id'],
        'participants': json['participants'],
        'sendStyle': json['send_style'] == null ? undefined : json['send_style'],
        'optedOut': json['opted_out'],
        'sendblueNumber': json['sendblue_number'] == null ? undefined : json['sendblue_number'],
        'service': json['service'],
        'groupDisplayName': json['group_display_name'] == null ? undefined : json['group_display_name'],
        'senderEmail': json['sender_email'] == null ? undefined : json['sender_email'],
        'seatId': json['seat_id'] == null ? undefined : json['seat_id'],
        'replyTo': json['reply_to'] == null ? undefined : SendblueMessageReferenceFromJSON(json['reply_to']),
        'threadOriginator': json['thread_originator'] == null ? undefined : SendblueMessageReferenceFromJSON(json['thread_originator']),
    };
}

export function SendblueMessageWebhookToJSON(json: any): SendblueMessageWebhook {
    return SendblueMessageWebhookToJSONTyped(json, false);
}

export function SendblueMessageWebhookToJSONTyped(value?: SendblueMessageWebhook | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accountEmail': value['accountEmail'],
        'content': value['content'],
        'is_outbound': value['isOutbound'],
        'status': value['status'],
        'error_code': value['errorCode'],
        'error_message': value['errorMessage'],
        'error_reason': value['errorReason'],
        'error_detail': value['errorDetail'],
        'message_handle': value['messageHandle'],
        'date_sent': value['dateSent'].toISOString(),
        'date_updated': value['dateUpdated'] == null ? value['dateUpdated'] : value['dateUpdated'].toISOString(),
        'from_number': value['fromNumber'],
        'number': value['number'],
        'to_number': value['toNumber'],
        'was_downgraded': value['wasDowngraded'],
        'plan': value['plan'],
        'media_url': value['mediaUrl'],
        'message_type': value['messageType'],
        'group_id': value['groupId'],
        'participants': value['participants'],
        'send_style': value['sendStyle'],
        'opted_out': value['optedOut'],
        'sendblue_number': value['sendblueNumber'],
        'service': value['service'],
        'group_display_name': value['groupDisplayName'],
        'sender_email': value['senderEmail'],
        'seat_id': value['seatId'],
        'reply_to': SendblueMessageReferenceToJSON(value['replyTo']),
        'thread_originator': SendblueMessageReferenceToJSON(value['threadOriginator']),
    };
}

